// Google Analytics 4 com consentimento explícito.
//
// Duas garantias importantes aqui:
//
// 1. Nenhum cookie é criado antes do usuário aceitar: o gtag.js só é baixado
//    depois do clique em "Aceitar" no banner.
// 2. O relatório reflete só o tráfego real. O build abre todas as rotas com
//    Puppeteer (scripts/prerender.mjs) a cada deploy e o desenvolvimento roda
//    em localhost — nenhum dos dois pode contar como visita.

const MEASUREMENT_ID = 'G-KD0W5HQ38V';
const STORAGE_KEY = 'bysetup:cookie-consent';
const MEASURABLE_HOSTS = ['bysetup.com', 'www.bysetup.com'];

function isMeasurableHost() {
  return typeof window !== 'undefined' && MEASURABLE_HOSTS.includes(window.location.hostname);
}

// Retorna 'granted', 'denied' ou null (ainda não decidiu).
export function getConsent() {
  try {
    return localStorage.getItem(STORAGE_KEY);
  } catch {
    // Navegação privativa ou storage bloqueado: trata como "não decidiu".
    return null;
  }
}

export function setConsent(value) {
  try {
    localStorage.setItem(STORAGE_KEY, value);
  } catch {
    // Sem persistir, o banner volta na próxima visita — melhor do que quebrar.
  }
}

let loaded = false;

function loadGtag() {
  if (loaded) return;
  loaded = true;

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${MEASUREMENT_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };
  window.gtag('js', new Date());
  // send_page_view: false — quem dispara os pageviews é trackPageView, porque
  // a navegação do React Router troca de página sem recarregar o documento.
  window.gtag('config', MEASUREMENT_ID, { send_page_view: false });
}

export function trackPageView(pathname) {
  if (!isMeasurableHost() || getConsent() !== 'granted') return;

  loadGtag();
  window.gtag('event', 'page_view', {
    page_path: pathname,
    page_location: window.location.href,
    page_title: document.title,
  });
}
